import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import PATH from "../../../constants/routes";
import StartQuizStatus from "./Components/StartQuizStatus";
import ResumeQuizStatus from "./Components/ResumeQuizStatus";

export default function QuizStatus(props) {
  const { subject_id, topic_id } = useParams();

  const navigate = useNavigate();
  return (
    <div>
      <ResumeQuizStatus />
      <StartQuizStatus />
      <button className="button button_primary" onClick={() => navigate(`../${subject_id}/${topic_id}/${PATH.PLAY_QUIZ_LINK}`)}>
        play
      </button>
    </div>
  );
}
